<template>
  <div id="app">
    <launcher
      :alwaysScrollToBottom="alwaysScrollToBottom"
      :onFullScreen="onFullScreen"
      :close="closeChat"
      :isOpen="isChatOpen"
      :messageList="messageList"
      :messageStyling="messageStyling"
      :newMessagesCount="newMessagesCount"
      :onMessageWasSent="onMessageWasSent"
      :open="openChat"
      :showCloseButton="true"
      :showLauncher="true"
      :showEmoji="false"
      :showFile="false"
      :showTypingIndicator="showTypingIndicator"
      :chatbotName="chatbotName"
      :chatbotImage="chatbotImage"
      :chatbotImageLauncher="chatbotImageLauncher"
      :chatbotImageFooter="chatbotImageFooter"
      :chatbotColors="chatbotColors"
      :chatbotChamada="chatbotChamada"
      :position="position"
      @onType="handleOnType"
      v-if="customerActive && chatbotName && chatbotImageLauncher && chatbotColors && chatbotChamada" />
  </div>
</template>

<script>
  import Launcher from './window/Launcher.vue'
  import messageHistory from './messageHistory'
  import interacoes from './interacoes'
  import { getBase64FromUrl } from '@/utils/image'
  import beep from './utils/beep'

  export default {
    name: 'App',
    components: {
      Launcher
    },
    mixins: [
      interacoes
    ],
    data() {
      return {
        messageList: messageHistory,
        newMessagesCount: 1,
        firstMessagesCount: true,
        isChatOpen: false,
        showTypingIndicator: '',
        backgroundColor: '#fff',
        alwaysScrollToBottom: true,
        messageStyling: true,
        userIsTyping: false,
        finished: false,
        chatbotImageBase64: '',
        lazyFullscreen: false,
        lazyVisible: true,
        position: 'right'
      }
    },
    computed: {
      chatbotName () {
        return this.$store.getters.chatbotName;
      },
      chatbotImage () {
        return this.$store.getters.chatbotImage;
      },
      chatbotImageLauncher () {
        return this.$store.getters.chatbotImageLauncher;
      },
      chatbotImageFooter () {
        return this.$store.getters.chatbotImageFooter;
      },
      chatbotColors () {
        return this.$store.getters.chatbotColors;
      },
      chatbotChamada () {
        return this.$store.getters.chatbotChamada;
      },
      customerActive () {
        return this.$store.getters.customerActive;
      }
    },
    watch: {
      chatbotImage (value) {
        if (!value) {
          return;
        }

        getBase64FromUrl(value).then(result => {
          this.chatbotImageBase64 = result;
        })
      }
    },
    created () {
      window.EventBus.$once('TOKEN_RECEIVED', token => {
        this.$store.commit('updateToken', token)
        this.settings()
      });

      window.EventBus.$once('ORIGEM_RECEIVED', origem => {
        this.$store.commit('updateOrigem', origem)
      });

      window.EventBus.$on('FULLSCREEN', fullscreen => {
        this.$store.commit('updateFullScreen', fullscreen)
      });

      window.EventBus.$on('LAZY_FULLSCREEN', fullscreen => {
        this.lazyFullscreen = fullscreen;
      });

      window.EventBus.$once('OPEN_CHAT', this.iniciarInteracao);

      window.EventBus.$on('OPEN_CHAT', () => {
        this.isChatOpen = true;

        if (this.finished) {
          window.EventBus.$emit('RESTART_CHAT');
          this.finished = false;
        }
      });

      window.EventBus.$on('CLOSE_CHAT', () => {
        this.isChatOpen = false
      });

      window.EventBus.$on('RESTART_CHAT', () => {
        this.firstMessagesCount = true;
        this.newMessagesCount   = 1;
        this.messageList        = [];

        this.iniciarInteracao();
      });

      window.EventBus.$on('FINISHED_CHAT', () => {
        this.finished = true;
      });

      window.EventBus.$on('LAZY_VISIBLE', visible => {
        this.lazyVisible = visible;
      });

      window.EventBus.$once('POSITION_LEFT', () => {
        this.position = 'left';
      });

      window.EventBus.$on('MESSAGE_WAS_SENT_BY_USER', this.interacaoMe);
      window.EventBus.$on('ON_MESSAGE_WAS_SENT', this.onMessageWasSent);
      window.EventBus.$on('ON_CONTINUE_TYPING', () => this.handleTyping('digitando...'));
      window.EventBus.$on('EDIT_ANSWER', this.editAnswer);
    },
    methods: {
      settings () {
        window.axios.post('/chatbot/settings', {
          token: this.$store.state.token
        }).then(response => {
          this.$store.commit('updateSettings', response.data);

          if (this.lazyVisible) {
            window.EventBus.$emit('VISIBLE');
          }

          setTimeout(() => {
            if (response.data.chatbotIniciarAberto) {
              this.openChat()
            }

            window.EventBus.$emit('FULLSCREEN', response.data.chatbotIniciarFullScreen || this.lazyFullscreen)
          }, 500);
        });
      },
      sendMessage(text) {
        if (text.length > 0) {
          this.onMessageWasSent({
            author: 'support',
            type: 'text',
            id: Math.random(),
            data: { text },
            automatic_answer: false
          })
        }
      },
      handleTyping(text) {
        this.showTypingIndicator = text.length > 0 ? 'support' : ''
      },
      onMessageWasSent(payload) {
        this.newMessagesCount   = this.newMessagesCount + (this.firstMessagesCount ? 0 : 1);
        this.firstMessagesCount = false;

        if (payload.author == 'me') {
          this.$store.commit('updateActiveUserInteraction', false);
          window.EventBus.$emit('MESSAGE_WAS_SENT_BY_USER', payload);
        } else if (payload.automatic_answer === false) {
          beep();
        }

        this.messageList = [
          ...this.messageList,
          Object.assign({}, payload, { id: Math.random() })
        ];
      },
      openChat() {
        window.EventBus.$emit('OPEN_CHAT');
      },
      closeChat() {
        window.EventBus.$emit('CLOSE_CHAT')
      },
      onFullScreen() {
        const fullscreen = !this.$store.getters.isFullScreen;
        window.EventBus.$emit('FULLSCREEN', fullscreen)
      },
      showStylingInfo() {
        this.$modal.show('dialog', {
          title: 'Info',
          text:
            'You can use *word* to <strong>boldify</strong>, /word/ to <em>emphasize</em>, _word_ to <u>underline</u>, `code` to <code>write = code;</code>, ~this~ to <del>delete</del> and ^sup^ or ¡sub¡ to write <sup>sup</sup> and <sub>sub</sub>'
        })
      },
      messageStylingToggled(e) {
        this.messageStyling = e.target.checked
      },
      handleOnType() {
        this.$root.$emit('onType')
        this.userIsTyping = true
      },
      editAnswer ({ fluxoInteracaoToken }) {
        this.$store.commit('updateActiveUserInteraction', false);
        this.$store.commit('updateProximoFluxoInteracaoToken', fluxoInteracaoToken);
        this.interacaoSupport();
      }
    }
  }
</script>

<style>
body {
  padding: 0px;
  margin: 0px;
}
* {
  font-family: Avenir Next, Helvetica Neue, Helvetica, sans-serif;
}
.demo-description {
  max-width: 500px;
}
.demo-description img {
  max-width: 500px;
}
.demo-test-area {
  width: 300px;
  box-sizing: border-box;
}
.demo-test-area--text {
  box-sizing: border-box;
  width: 100%;
  margin: 0px;
  padding: 0px;
  resize: none;
  font-family: Avenir Next, Helvetica Neue, Helvetica, sans-serif;
  background: #fafbfc;
  color: #8da2b5;
  border: 1px solid #dde5ed;
  font-size: 16px;
  padding: 16px 15px 14px;
  margin: 0;
  border-radius: 6px;
  outline: none;
  height: 150px;
  margin-bottom: 10px;
}
.demo-monster-img {
  width: 400px;
  display: block;
  margin: 60px auto;
}
.text-center {
  text-align: center;
}
.colors a {
  color: #fff;
  text-decoration: none;
  padding: 4px 10px;
  border-radius: 10px;
}
.toggle a {
  text-decoration: none;
}
.messageStyling {
  font-size: small;
}
.select2-container {
  outline: none;
}
.select2-container .select2-selection--single {
  height: 39px;
  outline: none;
}
.select2-container--default .select2-selection--single {
  background-color: #eaeaea;
  border: 0;
  border-radius: 20px;
}
.select2-container--default .select2-selection--single .select2-selection__rendered {
  padding: 10px 15px;
  font-size: 14px;
  line-height: 1.4;
  -webkit-font-smoothing: subpixel-antialiased;
}
.select2-container--default .select2-selection--single .select2-selection__arrow {
  width: 45px;
  height: 39px;
  top: 0;
  right: 0;
}
.select2-dropdown {
  background-color: #eaeaea;
  border-radius: 20px;
  overflow: hidden;
  border: 0;
}
.select2-dropdown--above .select2-search--dropdown {
  display: block;
  padding: 10px 15px;
}
.select2-dropdown--below .select2-search--dropdown {
  display: block;
  padding: 0 15px 10px;
}
.select2-container--default .select2-search--dropdown .select2-search__field {
  border: 0;
  border-radius: 20px;
  padding: 4px 10px;
  outline: none;
}
.select2-results__option {
  padding: 8px 15px;
  font-size: 14px;
  line-height: 1.4;
  -webkit-font-smoothing: subpixel-antialiased;
}
.coberturas-content table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.7rem;
}
.coberturas-content tr:nth-of-type(odd) {
  background-color: white;
}
.coberturas-content td {
  border: 1px solid white;
  padding: .4rem;
  vertical-align: top;
}
.container-html {
  width: 100%;
  margin-top: 10px;
}
.container-html table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.7rem;
}
.container-html tr:nth-of-type(odd) {
  background-color: white;
}
.container-html td {
  border: 1px solid white;
  padding: .4rem;
  vertical-align: top;
}
</style>
